import * as ofbiz from '../server/ofbiz';
import Utils from '../script/utils.js';
import nls from '../script/properties';

import * as requestDataActions from './requestData_action';
import { createOperationAudit } from './operationAudit_action';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_ALARMLOGLIST = 'SET_ALARMLOGLIST';
export const SET_ALARMLOGCOUNT = 'SET_ALARMLOGCOUNT';
export const SET_ALARMNAMELIST = 'SET_ALARMNAMELIST';
export const SET_ALARMEQUIPMENT = 'SET_ALARMEQUIPMENT';
export const SET_ALARMRULEID = 'SET_ALARMRULEID';
export const SET_ALARMRULELIST = 'SET_ALARMRULELIST';
export const SET_SMSTEMPLATE = 'SET_SMSTEMPLATE';
export const SET_MAILTEMPLATE = 'SET_MAILTEMPLATE';
export const SET_STAFF = 'SET_STAFF';
export const SET_ALARMRULE = 'SET_ALARMRULE';
export const SET_TEMPLATELIST = 'SET_TEMPLATELIST';
export const SET_SMSSERVERSTATUS = 'SET_SMSSERVERSTATUS';

export const SET_ALARM_USERSLIST = 'SET_ALARM_USERSLIST';
export const SET_ALARM_USERSTOTAL = 'SET_ALARM_USERSTOTAL';
export const SET_ALARM_SELECTEDUSERS = 'SET_ALARM_SELECTEDUSERS';

export const SET_ALARM_EVENTLIST = 'SET_ALARM_EVENTLIST';
export const SET_MAILSERVERSETTING = 'SET_MAILSERVERSETTING';
export const SET_SMSSENDSETTING = 'SET_SMSSENDSETTING';
export const SET_ALARMRULESELECTEDEQUIPMENTS = 'SET_ALARMRULESELECTEDEQUIPMENTS';
export const SET_DUTYDATA = 'SET_DUTYDATA';
export const SET_PROFILEDATA = 'SET_PROFILEDATA';
export const SET_USERALARMSTAFFMAP = 'SET_USERALARMSTAFFMAP';
export const SET_PROFILEMAP = 'SET_PROFILEMAP';
export const SET_ALARMLOGS = 'SET_ALARMLOGS';
export const SET_SENDLOGDATA = 'SET_SENDLOGDATA';
export const SET_ALLEQUIPMENTS = 'SET_ALLEQUIPMENTS';
export const SET_ECCMONITORLIST = 'SET_ECCMONITORLIST';
export const SET_MONITOROPTIONS = 'SET_MONITOROPTIONS';
export const SET_MONITORITEMSMAP = 'SET_MONITORITEMSMAP';

const DEFAULT_MAIL_SETTINGS = {
  SendServer: '',
  MailAddress: '',
  BackupSendServer: '',
  MailUserName: '',
  MailPwd: '',
};

const DEFAULT_SMS_SETTINGS = {
  SMSUserName: '',
  SMSPwd: '',
  SMSLength: '',
  TaskPlanType: '',
  MouldId: '',
};

const LEVEL_FROM_OLD = {
  error: 'IT_AL_CRITICAL',
  warning: 'IT_AL_WARNING',
  good: 'IT_AL_INFO',
  '严重告警': 'IT_AL_CRITICAL',
  '主要告警': 'IT_AL_MAJOR',
  '次要告警': 'IT_AL_MINOR',
  '警告告警': 'IT_AL_WARNING',
};

const STATUS_FROM_OLD = {
  1: 'IT_AL_ACTIVE',
  2: 'IT_AL_CONFIRMED',
  4: 'IT_AL_CLOSED',
};

const compact = obj => Object.keys(obj).reduce((memo, key) => {
  const value = obj[key];
  if (value !== undefined && value !== null && value !== '') {
    memo[key] = value;
  }
  return memo;
}, {});

const getPageList = res => (res && Array.isArray(res.list) ? res.list : []);
const getPageTotal = res => Number((res && (res.total || res.count)) || 0);

// 规则字段映射：输出名 → [新驼峰, 老版驼峰]（见 doc/15-告警规则接口文档）
const RULE_FIELD_MAP = [
  ['ruleId', ['ruleId', 'RecId']],
  ['ruleName', ['ruleName', 'AlarmName']],
  ['description', ['description', 'AlarmDesc']],
  ['dutyGroup', ['dutyGroup', 'DutyGroup']],
  ['alarmLevel', ['alarmLevel', 'AlarmLevel']],
  ['isRecover', ['isRecover', 'IsRecover'], 'bool'],
  ['errorAlarm', ['errorAlarm', 'ErrorAlarm'], 'bool'],
  ['warningAlarm', ['warningAlarm', 'WarningAlarm'], 'bool'],
  ['stopTimes', ['stopTimes', 'StopTimes'], 'num'],
  ['alarmFilter', ['alarmFilter', 'AlarmFilter'], 'num'],
  ['alarmStart', ['alarmStart', 'AlarmStart'], 'num'],
  ['alarmEnd', ['alarmEnd', 'AlarmEnd'], 'num'],
  ['alarmStrategy', ['alarmStrategy', 'AlarmStrategy'], 'bool'],
  ['strategyIndex', ['strategyIndex', 'StrategyIndex'], 'num'],
  ['startTime', ['startTime', 'StartTime']],
  ['endTime', ['endTime', 'EndTime']],
  ['emailEnabled', ['emailEnabled', 'EamilAlarm'], 'bool'],
  ['emailTemplate', ['emailTemplate', 'MailTemplates']],
  ['smsEnabled', ['smsEnabled', 'SMSAlarm'], 'bool'],
  ['smsTemplate', ['smsTemplate', 'SMSTemplates']],
  ['wechatEnabled', ['wechatEnabled', 'WeChatAlarm'], 'bool'],
  ['wechatUser', ['wechatUser', 'WeChatUser']],
  ['upgradeTimes', ['upgradeTimes', 'UpgradeTimes'], 'num'],
];

const firstOf = (obj, keys) => {
  for (let i = 0; i < keys.length; i++) {
    if (obj[keys[i]] !== undefined && obj[keys[i]] !== null) return obj[keys[i]];
  }
  return undefined;
};

const toYN = v => {
  if (v === undefined || v === null || v === '') return undefined;
  return (v === true || v === 'Y' || v === 'y' || v === 1 || v === '1') ? 'Y' : 'N';
};

const toRuleNum = v => {
  if (v === undefined || v === null || v === '') return undefined;
  const n = Number(v);
  return Number.isNaN(n) ? undefined : n;
};

const toCsvList = v => {
  if (v === undefined || v === null) return undefined;
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') return v.split(',').map(s => s.trim()).filter(Boolean);
  return [v];
};

/**
 * 报警规则载荷归一化：老版驼峰（弹窗提交）与后端 camelCase 字段双兼容。
 * 文本字段显式传空串表示清空；布尔统一转 Y/N；名单/设备支持数组或 CSV。
 */
const normalizeRulePayload = (params = {}) => {
  const source = params.alarmRule || params;
  const payload = {};
  RULE_FIELD_MAP.forEach(([outName, candidates, kind]) => {
    const raw = firstOf(source, candidates);
    if (raw === undefined) return;
    if (kind === 'bool') {
      payload[outName] = toYN(raw);
      return;
    }
    if (kind === 'num') {
      payload[outName] = toRuleNum(raw);
      return;
    }
    payload[outName] = raw;
  });
  const equipmentIds = toCsvList(firstOf(source, ['equipmentIds']));
  if (equipmentIds !== undefined) payload.equipmentIds = equipmentIds;
  const recipients = toCsvList(firstOf(source, ['recipients']));
  if (recipients !== undefined) payload.recipients = recipients;
  const upgradeRecipients = toCsvList(firstOf(source, ['upgradeRecipients']));
  if (upgradeRecipients !== undefined) payload.upgradeRecipients = upgradeRecipients;
  return payload;
};

const normalizeEventQuery = (params = {}) => compact({
  currentStatusId: STATUS_FROM_OLD[params.currentStatusId || params.AlarmStatus] || params.currentStatusId || params.AlarmStatus,
  equipmentId: params.equipmentId || params.EquipmentRecId || params.EquipmentId,
  monitorId: params.monitorId || params.MonitorId || params.MonitorType,
  alarmLevel: LEVEL_FROM_OLD[params.alarmLevel || params.MonitorStatus] || params.alarmLevel || params.MonitorStatus,
  ruleId: params.ruleId || params.AlarmConfigRecId,
  startTime: params.startTime,
  endTime: params.endTime,
});

const normalizeTemplatePayload = (params = {}) => compact({
  emailTemplateSettingId: params.emailTemplateSettingId || params.RecId,
  description: params.description || params.MailTitle,
  fromAddress: params.fromAddress,
  ccAddress: params.ccAddress,
  bccAddress: params.bccAddress,
  subject: params.subject || params.MailModle || params.MailTitle,
  bodyScreenLocation: params.bodyScreenLocation || params.MailContent,
  contentType: params.contentType || 'text/html',
});

const unsupported = (message, callback, result = 0) => {
  Utils.showMessageDialog('提示', message, 'warning');
  callback && callback(result);
};

export function setMonitorItemsMap(monitorItemsMap) {
  return { type: SET_MONITORITEMSMAP, monitorItemsMap };
}

export function setEccMonitorList(eccMonitorList) {
  return { type: SET_ECCMONITORLIST, eccMonitorList };
}

export function setAllEquipments(allEquipments) {
  return { type: SET_ALLEQUIPMENTS, allEquipments };
}

export function setAlarmLogs(alarmLogs) {
  return { type: SET_ALARMLOGS, alarmLogs };
}

export function setSendLogData(sendLogData) {
  return { type: SET_SENDLOGDATA, sendLogData };
}

export function setProfileMap(profileMap) {
  return { type: SET_PROFILEMAP, profileMap };
}

export function setUserAlarmStaffMap(userAlarmStaffMap) {
  return { type: SET_USERALARMSTAFFMAP, userAlarmStaffMap };
}

export function setProfileData(profileData) {
  return { type: SET_PROFILEDATA, profileData };
}

export function setDutyData(dutyData) {
  return { type: SET_DUTYDATA, dutyData };
}

export function setAlarmRuleSelectedEquipments(alarmRuleSelectedEquipments) {
  return { type: SET_ALARMRULESELECTEDEQUIPMENTS, alarmRuleSelectedEquipments };
}

export function setMailServerSetting(mailSettings) {
  return { type: SET_MAILSERVERSETTING, mailSettings };
}

export function setSMSSendSetting(smsSettings) {
  return { type: SET_SMSSENDSETTING, smsSettings };
}

export function setPermissions(permissions) {
  return { type: SET_PERMISSIONS, permissions };
}

export function setAlarmNameList(alarmNameList) {
  return { type: SET_ALARMNAMELIST, alarmNameList };
}

export function setAlarmEquipment(alarmEquipment) {
  return { type: SET_ALARMEQUIPMENT, alarmEquipment };
}

export function setAlarmLogList(alarmLogList) {
  return { type: SET_ALARMLOGLIST, alarmLogList };
}

export function setAlarmLogCount(alarmLogCount) {
  return { type: SET_ALARMLOGCOUNT, alarmLogCount };
}

export function setAlarmRuleID(alarmRuleID) {
  return { type: SET_ALARMRULEID, alarmRuleID };
}

export function setAlarmRuleList(alarmRuleList) {
  return { type: SET_ALARMRULELIST, alarmRuleList };
}

export function setAlarmEventList(alarmEventList) {
  return { type: SET_ALARM_EVENTLIST, alarmEventList };
}

export function setSmsTemplate(smsTemplate) {
  return { type: SET_SMSTEMPLATE, smsTemplate };
}

export function setMailTemplate(mailTemplate) {
  return { type: SET_MAILTEMPLATE, mailTemplate };
}

export function setStaff(staff) {
  return { type: SET_STAFF, staff };
}

export function setAlarmRule(alarmRule) {
  return { type: SET_ALARMRULE, alarmRule };
}

export function setTempleteList(templeteList) {
  return { type: SET_TEMPLATELIST, templeteList };
}

export function setSmsServerStatus(smsServerStatus) {
  return { type: SET_SMSSERVERSTATUS, smsServerStatus };
}

export function setAlarmUsersList(alarmUsersList) {
  return { type: SET_ALARM_USERSLIST, alarmUsersList };
}

export function setAlarmUsersTotal(alarmUserTotal) {
  return { type: SET_ALARM_USERSTOTAL, alarmUserTotal };
}

export function setAlarmSelectedUsers(alarmSelectedUsers) {
  return { type: SET_ALARM_SELECTEDUSERS, alarmSelectedUsers };
}

export function receiveCreateOperationAudit(param) {
  return dispatch => {
    dispatch(createOperationAudit(param));
  };
}

export function getAlarmLogList(param) {
  return dispatch => {
    dispatch(setAlarmLogList([]));
    dispatch(setAlarmLogCount(0));
    param && param.callback && param.callback({ alarmLogList: [], alarmLogCount: 0 });
  };
}

export function getAlarmLogPageData(param) {
  return dispatch => {
    dispatch(getAlarmLogList(param));
  };
}

export function getAlarmRuleList(callback, query = {}) {
  return dispatch => {
    ofbiz.getAlarmRuleList(query, 1, 500).then(res => {
      const list = getPageList(res);
      dispatch(setAlarmRuleList(list));
      callback && callback(list);
    }).catch(err => {
      dispatch(setAlarmRuleList([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

export function getEquipmentDropDownData(param) {
  return dispatch => {
    dispatch(setAlarmEquipment([]));
    param && param.callback && param.callback([]);
  };
}

export function getAlarmEvent(params = {}, callback) {
  return dispatch => {
    ofbiz.getAlarmEventList(normalizeEventQuery(params), 1, 500).then(res => {
      const list = getPageList(res);
      dispatch(setAlarmEventList(list));
      callback && callback(list);
    }).catch(err => {
      dispatch(setAlarmEventList([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

export function getAlarmEventLogs(params = {}, callback, only) {
  return dispatch => {
    ofbiz.getAlarmEventList(normalizeEventQuery(params), 1, 500).then(res => {
      const list = getPageList(res);
      if (!only) {
        dispatch(setAlarmEventList(list));
      }
      callback && callback(list);
    }).catch(err => {
      if (!only) {
        dispatch(setAlarmEventList([]));
      }
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

export function deleteAlarmRule(ruleId, callback, errorCallback) {
  return () => {
    ofbiz.deleteAlarmRule(ruleId).then(data => {
      callback && callback(data || {});
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      errorCallback && errorCallback(err);
    });
  };
}

export function getEquipmentByAlarmConfigRecId(ruleId, callback) {
  return dispatch => {
    ofbiz.getAlarmRuleById(ruleId).then(rule => {
      // 规则 VO 返回勾选设备清单（equipments[{equipmentId,equipmentName}] / equipmentIds）
      let selected = [];
      if (rule && Array.isArray(rule.equipments) && rule.equipments.length > 0) {
        selected = rule.equipments.map(item => ({ equipmentId: item.equipmentId }));
      } else if (rule && Array.isArray(rule.equipmentIds)) {
        selected = rule.equipmentIds.map(equipmentId => ({ equipmentId }));
      } else if (rule && rule.equipmentId) {
        selected = [{ equipmentId: rule.equipmentId }];
      }
      dispatch(setAlarmRuleSelectedEquipments(selected));
      callback && callback(selected);
    }).catch(() => {
      dispatch(setAlarmRuleSelectedEquipments([]));
      callback && callback([]);
    });
  };
}

export function createAlarmRule(params, callback, errorCallback) {
  return () => {
    ofbiz.createAlarmRule(normalizeRulePayload(params)).then(data => {
      callback && callback(data || {});
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      errorCallback && errorCallback(err);
    });
  };
}

export function updateAlarmRule(params, callback, errorCallback) {
  return () => {
    ofbiz.updateAlarmRule(normalizeRulePayload(params)).then(data => {
      callback && callback(data || {});
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      errorCallback && errorCallback(err);
    });
  };
}

export function updateEquipmentAlarmConfigRecId(params, callback) {
  return () => {
    callback && callback(params);
  };
}

export function getEmailServerConfig(callback) {
  return dispatch => {
    dispatch(setMailServerSetting(DEFAULT_MAIL_SETTINGS));
    callback && callback(1);
  };
}

export function getSMSServerConfig(callback) {
  return dispatch => {
    dispatch(setSMSSendSetting(DEFAULT_SMS_SETTINGS));
    callback && callback(1);
  };
}

export function getSMSServerStatus(callback) {
  return dispatch => {
    dispatch(setSmsServerStatus(false));
    callback && callback(false);
  };
}

export function getMailAndSMSTemplate(callback) {
  return dispatch => {
    ofbiz.getMailTemplateList({}, 1, 500).then(res => {
      const list = getPageList(res);
      dispatch(setMailTemplate(list));
      dispatch(setSmsTemplate([]));
      callback && callback({ mail: list, sms: [] });
    }).catch(err => {
      dispatch(setMailTemplate([]));
      dispatch(setSmsTemplate([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback({ mail: [], sms: [] });
    });
  };
}

export function createTemplate(params, callback) {
  return () => {
    ofbiz.createMailTemplate(normalizeTemplatePayload(params)).then(() => {
      Utils.showMessageDialog('提示', '添加模板成功');
      callback && callback(1);
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback(0);
    });
  };
}

export function updateTemplate(params, callback) {
  return () => {
    ofbiz.updateMailTemplate(normalizeTemplatePayload(params)).then(() => {
      Utils.showMessageDialog('提示', '更新模板成功');
      callback && callback(1);
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback(0);
    });
  };
}

export function deleteTemplate(emailTemplateSettingId, callback) {
  return () => {
    ofbiz.deleteMailTemplate(emailTemplateSettingId).then(data => {
      callback && callback(data || {});
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback({ errorCode: err.code || 500 });
    });
  };
}

export function updateEmailServerConfig(params, callback) {
  return () => unsupported('新接口文档暂未提供邮件服务器配置保存接口', callback, 0);
}

export function updateSMSServerConfig(params, callback) {
  return () => unsupported('新接口文档暂未提供短信服务器配置保存接口', callback, 0);
}

export function getDutyData(callback) {
  return dispatch => {
    dispatch(setDutyData([]));
    callback && callback([]);
  };
}

export function getUserAlarmStaff(AlarmConfigRecIds, callback) {
  return dispatch => {
    dispatch(setUserAlarmStaffMap({}));
    callback && callback({});
  };
}

export function get_alarm_allUsers(filter) {
  return dispatch => {
    dispatch(setAlarmUsersTotal(0));
    dispatch(setAlarmUsersList([]));
  };
}

export function getChatRoomAddress(param) {
  return () => {
    param && param.callback && param.callback('');
  };
}

export function startOrStopAlarmRule(params, callback) {
  return () => {
    const ruleId = params.ruleId || params.RecId;
    ofbiz.toggleAlarmRule(ruleId).then(data => {
      callback && callback(data || {});
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback({ errorCode: err.code || 500 });
    });
  };
}

export function getProfileData(callback) {
  return dispatch => {
    ofbiz.getNotifyStaffList({}, 1, 500).then(res => {
      const list = getPageList(res);
      const profileMap = {};
      list.forEach(item => {
        profileMap[item.partyId] = item;
      });
      dispatch(setProfileData(list));
      dispatch(setProfileMap(profileMap));
      callback && callback(list);
    }).catch(err => {
      dispatch(setProfileData([]));
      dispatch(setProfileMap({}));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

export function getSelectedUpdateUsersList(param) {
  return () => {
    param && param.callback && param.callback([]);
  };
}

export function addUserAlarmStaff(params, callback) {
  return () => {
    const partyId = params.partyId || params.UserLogID;
    if (!partyId) {
      callback && callback({});
      return;
    }
    ofbiz.addNotifyStaff(partyId).then(data => callback && callback(data || {})).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback({ errorCode: err.code || 500 });
    });
  };
}

export function deleteUserAlarmStaff(partyId, callback) {
  return () => {
    if (!partyId) {
      callback && callback({});
      return;
    }
    ofbiz.removeNotifyStaff(partyId).then(data => callback && callback(data || {})).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback({ errorCode: err.code || 500 });
    });
  };
}

export function updateUserAlarmStaff(params, callback) {
  return () => {
    callback && callback(params);
  };
}

export function getSendLogs(params = {}, callback) {
  return dispatch => {
    const pageSize = Number(params.pageSize || params.pagesize || 20);
    const page = params.page || (params.fromindex ? Math.floor(Number(params.fromindex) / pageSize) + 1 : 1);
    ofbiz.getMailHistory(compact({
      startTime: params.startTime,
      endTime: params.endTime,
      equipmentId: params.equipmentId || params.EquipmentId,
      alarmName: params.alarmName || params.AlarmName,
    }), page, pageSize).then(res => {
      dispatch(setSendLogData({
        list: getPageList(res),
        total: getPageTotal(res),
        page: res.page || page,
        pageSize: res.pageSize || pageSize,
      }));
      callback && callback(1);
    }).catch(err => {
      dispatch(setSendLogData({ list: [], total: 0, page, pageSize }));
      Utils.showInterfaceErrorInfo(err);
      callback && callback(0);
    });
  };
}

export function getAllEquipments(callback) {
  return dispatch => {
    ofbiz.getEquipmentOptions().then(list => {
      const data = (list || []).map(item => ({
        RecId: item.equipmentId,
        Title: item.fixedAssetName,
        ServerAddress: item.ipAddress || '',
      }));
      if (data.length > 0) {
        data.unshift({ Title: '全部', RecId: '' });
      }
      dispatch(setAllEquipments(data));
      callback && callback(data);
    }).catch(err => {
      dispatch(setAllEquipments([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

// 监测器类型字典（老版语义：label=MonitorName 中文名，value=类型短码如 Ping/Port）
// 供巡检日志查询/TopN 报表等按类型聚合的页面使用，与 getMonitorOptions（实例列表）语义不同
export function getEccMonitorList(callback, withNull) {
  return dispatch => {
    ofbiz.getMonitorTypes({}).then(res => {
      const list = Array.isArray(res) ? res : getPageList(res);
      // 按 MonitorName 去重，保留首个类型码
      const typeMap = {};
      (list || []).forEach(item => {
        const key = item.MonitorName;
        if (key && !(key in typeMap)) {
          typeMap[key] = item.MonitorType;
        }
      });
      const monitorList = Object.keys(typeMap).map(label => ({ label, value: typeMap[label] }));
      if (withNull) {
        monitorList.unshift({ label: '全部', value: '' });
      }
      dispatch(setEccMonitorList(monitorList));
      callback && callback(monitorList);
    }).catch(err => {
      dispatch(setEccMonitorList([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

// 监测器实例下拉列表（value=monitorId），供报警事件页按监测器实例过滤
export function setMonitorOptions(monitorOptions) {
  return { type: SET_MONITOROPTIONS, monitorOptions };
}

export function getMonitorOptions(callback, withNull) {
  return dispatch => {
    ofbiz.getMonitorList({}, 1, 500).then(res => {
      const monitorOptions = getPageList(res).map(item => ({
        label: item.monitorName || item.fixedAssetName || item.monitorId,
        value: item.monitorId,
        monitorType: item.monitorType,
      }));
      if (withNull) {
        monitorOptions.unshift({ label: '全部', value: '' });
      }
      dispatch(setMonitorOptions(monitorOptions));
      callback && callback(monitorOptions);
    }).catch(err => {
      dispatch(setMonitorOptions([]));
      Utils.showInterfaceErrorInfo(err);
      callback && callback([]);
    });
  };
}

export function getMonitorItems(callback) {
  return dispatch => {
    ofbiz.getMonitorTypes({}).then(types => {
      // 接口返回 {list:[...], total} 分页结构，需先解包再遍历
      const typeList = Array.isArray(types) ? types : getPageList(types);
      // 收集去重后的类型短码，用后端 monitorTypes 批量参数一次请求全部指标项。
      // 旧版逐类循环请求去重后仍有 175+ 次 XHR，浏览器并发排队需 40 秒以上，
      // 期间巡检日志报表等页面的下拉框长时间无数据。
      const seen = {};
      const codes = [];
      (typeList || []).forEach(type => {
        const monitorType = type.monitorType || type.MONITOR_TYPE || type.value;
        if (monitorType && !seen[monitorType]) {
          seen[monitorType] = true;
          codes.push(monitorType);
        }
      });
      return ofbiz.getMonitorReturnItemsBatch(codes.join(',')).then(res => {
        // 批量返回的行内 monitorType 为原始类型短码，按短码分组构建 monitorItemsMap
        const itemList = Array.isArray(res) ? res : getPageList(res);
        const monitorItemsMap = {};
        (itemList || []).forEach(item => {
          const monitorType = item.monitorType;
          if (!monitorType) return;
          const value = item.returnItem || item.saveItem || item.value || item.itemName;
          if (!monitorItemsMap[monitorType]) monitorItemsMap[monitorType] = [];
          monitorItemsMap[monitorType].push({ label: nls[value] || item.label || value, value });
        });
        dispatch(setMonitorItemsMap(monitorItemsMap));
        callback && callback(monitorItemsMap);
      });
    }).catch(err => {
      dispatch(setMonitorItemsMap({}));
      Utils.showInterfaceErrorInfo(err);
      callback && callback({});
    });
  };
}

export function testSend(params, callback) {
  return () => {
    if (params.type !== 'email') {
      unsupported('新接口文档暂未提供短信/微信测试发送接口', callback, 0);
      return;
    }
    ofbiz.testMail({
      toAddress: params.user,
      subject: 'ITOSS 测试邮件',
      content: params.info || 'ITOSS test mail',
      sendFrom: params.sendFrom,
    }).then(() => {
      Utils.showMessageDialog('提示', '测试邮件已发送', 'success');
      callback && callback(1);
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback(0);
    });
  };
}

export function startOrStopAlarmEvent(params, callback) {
  return () => {
    const eventId = params.eventId || params.RecId;
    const task = params.opt === '2'
      ? ofbiz.closeAlarmEvent(eventId, params.note || '')
      : ofbiz.confirmAlarmEvent(eventId, params.note || '');
    task.then(() => {
      callback && callback(true);
    }).catch(err => {
      Utils.showInterfaceErrorInfo(err);
      callback && callback(false);
    });
  };
}
